module.exports = __webpack_public_path__ + "img/stan.c79c721d.png";